import React, { useEffect, useState } from "react";
import LOGO_WHITE from "../../../assets/v4-reports-assets/images/logo-white.png";
import TM_LOGO from "../../../assets/v4-reports-assets/icons/tm-logo.png";
import APP_CLOUD from "../../../assets/v4-reports-assets/images/app-cloud.png";
import IMAGE_1 from "../../../assets/v4-reports-assets/images/carousel-image-one.png";
import IMAGE_2 from "../../../assets/v4-reports-assets/images/carousel-image-two.png";
import IMAGE_3 from "../../../assets/v4-reports-assets/images/carousel-image-three.png";
import RAIN_DROPS from "../../../assets/v4-reports-assets/icons/rain-drops.png";
import CAUTION_ICON from "../../../assets/v4-reports-assets/icons/caution.png";
import WIND_BLOW from "../../../assets/v4-reports-assets/icons/wind-blow.png";
import BODY_1 from "../../../assets/v4-reports-assets/images/carousel-body-one-image.png";
import BODY_2 from "../../../assets/v4-reports-assets/images/carousel-body-two-image.png";
import BODY_3 from "../../../assets/v4-reports-assets/images/carousel-body-three-image.png";
import TARGET from "../../../assets/v4-reports-assets//icons/target.png";
import TITLE from "../../../assets/v4-reports-assets/images/Damage Title.png";
import DATA_TRAIL from "../../../assets/v4-reports-assets/images/data-trail.png";
import "./styles.scss";

const SLIDES_INTERVAL_TIME = 5000;
const ANIMATION_DIRECTION = "right";

const Section2 = ({
  damageMetricsImage,
  hailImpacts,
  anomalies,
  windDamages,
  // hailStorms,
  moistureExposure,
}) => {
  const [inFocus, setInfocus] = useState();
  const slidesCount = 3;

  useEffect(() => {
    setInfocus(0);
  }, []);

  const prevSlide = (count) => {
    setInfocus((s) => (s === 0 ? count - 1 : s - 1));
  };
  const nextSlide = (count) => {
    setInfocus((s) => (s === count - 1 ? 0 : s + 1));
  };

  // useEffect(() => {
  //   const automatedSlide = setInterval(() => {
  //     ANIMATION_DIRECTION.toLowerCase() === "left"
  //       ? prevSlide(slidesCount)
  //       : nextSlide(slidesCount);
  //   }, SLIDES_INTERVAL_TIME);
  //   return () => clearInterval(automatedSlide);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return (
    <>
      <section class="hero-section section-2">
        <div class="hero-section__content-box">
          <div class="hero-section__content-box--header">
            {/* <div class="logo">
              <img
                src={LOGO_WHITE}
                alt="remote roofing logo"
                class="actual-image"
              />
            </div>
            <h2 class="title">
              Damage Intelligence
              <img src={TM_LOGO} alt="trademark logo" class="tm-logo" />
            </h2> */}
            <img
              style={{ height: "84px", width: "auto", marginBottom: "2rem" }}
              src={TITLE}
            />
          </div>

          <div class="hero-section__content-box--cloud">
            <img
              src={APP_CLOUD}
              alt="remote roofing cloud"
              class="actual-image"
            />
          </div>

          <div class="image-container">
            <div class="secondary-images">
              <div
                className={`secondary-images__shot_1 secondary-image  ${
                  inFocus === 0 ? "primary-image" : ""
                }`}
              >
                {/* <img src={damageMetricsImage} /> */}
                <div
                  style={{
                    height: inFocus === 0 ? "200px" : "100px",
                    width: "auto",
                    background: `url(${damageMetricsImage})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    borderRadius: "30px",

                    // transform: inFocus !== 0 ? "rotate(60deg)" : " ",
                  }}
                />
                <h1 class="image-label">Damage Metrics</h1>
              </div>
              <div
                className={`secondary-images__shot_1 secondary-image  ${
                  inFocus === 1 ? "primary-image" : ""
                }`}
              >
                {/* <img src={IMAGE_2} /> */}
                <div
                  style={{
                    background: `url(${IMAGE_2})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    height: inFocus === 1 ? "200px" : "100px",
                    borderRadius: "30px",

                    // transform:
                    //   inFocus === 0
                    //     ? "rotate(60deg)"
                    //     : inFocus === 2
                    //     ? "rotate(-60deg)"
                    //     : " ",
                    width: "auto",
                  }}
                />{" "}
                <h1 class="image-label">Impact Analysis </h1>
              </div>
              <div
                className={`secondary-images__shot_1 secondary-image  ${
                  inFocus === 2 ? "primary-image" : ""
                }`}
              >
                {/* <img src={moistureExposure} /> */}

                <div
                  style={{
                    background: `url(${moistureExposure})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    height: inFocus === 2 ? "200px" : "100px",
                    width: "auto",
                    // transform: "rotate(-60deg)",
                    borderRadius: "30px",
                  }}
                />
                <h1 class="image-label">Moisture Exposure</h1>
              </div>
            </div>
          </div>

          <div class="position-trackers">
            <div
              onClick={() => setInfocus(0)}
              className={`tracker ${inFocus === 0 ? "in-focus" : ""}`}
              class="tracker "
            ></div>
            <div
              onClick={() => setInfocus(1)}
              className={`tracker ${inFocus === 1 ? "in-focus" : ""}`}
              class="tracker "
            ></div>
            <div
              onClick={() => setInfocus(2)}
              className={`tracker ${inFocus === 2 ? "in-focus" : ""}`}
              class="tracker "
            ></div>
          </div>

          <section class="hero-carousel-body">
            <div className={`carousel-body ${inFocus === 0 ? "in-focus" : ""}`}>
              <div class="grid-col-one">
                <div class="body-item">
                  <img src={RAIN_DROPS} alt="" class="body-item__image" />
                  <div>
                    <h4 class="body-item__title">
                      {hailImpacts === 0 ? "N/A" : hailImpacts}
                    </h4>
                    <p style={{ color: "#c4c4c4" }} class="body-item__caption">
                      Hail Impacts
                    </p>
                  </div>
                </div>
                <div class="body-item">
                  <img src={CAUTION_ICON} alt="" class="body-item__image" />
                  <div>
                    <h4 class="body-item__title pink">
                      {anomalies === 0 ? "N/A" : anomalies}
                    </h4>
                    <p style={{ color: "#c4c4c4" }} class="body-item__caption">
                      Anomalies
                    </p>
                  </div>
                </div>
                <div class="body-item">
                  <img src={WIND_BLOW} alt="" class="body-item__image" />
                  <div>
                    <h4 class="body-item__title yellow">
                      {windDamages === 0 ? "N/A" : windDamages}
                    </h4>
                    <p style={{ color: "#c4c4c4" }} class="body-item__caption">
                      Wind Damages
                    </p>
                  </div>
                </div>
              </div>
              <div class="grid-col-two">
                <img
                  src={BODY_1}
                  alt=""
                  class="carousel-body-grid-image carousel-one-image"
                />
              </div>
            </div>

            <div className={`carousel-body ${inFocus === 1 ? "in-focus" : ""}`}>
              <div class="iframe grid-col-two">
                <iframe
                  className="airtable-embed"
                  src="https://airtable.com/embed/shryfYUTAPS9OuISm?backgroundColor=red&layout=card"
                  frameborder="0"
                  onmousewheel=""
                  width="120%"
                  height="300px"
                  style={{
                    background: "transparent",
                    border: "1px solid #ccc",
                  }}
                ></iframe>
              </div>
              <div class=" iframe-partner grid-col-one">
                <div class="  push-down body-item">
                  <img
                    src={TARGET}
                    alt=""
                    class=" push-down body-item__image"
                  />
                  <div>
                    <h4
                      style={{ color: "#EF9797" }}
                      class=" push-down body-item__title pink"
                    >
                      {hailImpacts === 0 ? "N/A" : hailImpacts} hail impacts
                    </h4>

                    <p class="body-item__caption">latitudes x longitudes</p>
                  </div>
                </div>
                <div class="body-item">
                  <img src={RAIN_DROPS} alt="" class="body-item__image" />
                  <div>
                    <h4 class="body-item__title">3 hail storms</h4>
                    <p class="body-item__caption">recorded in database</p>
                  </div>
                </div>
              </div>
            </div>

            <div className={`carousel-body ${inFocus === 2 ? "in-focus" : ""}`}>
              <div class=" third-left grid-col-two">
                <img
                  src={BODY_3}
                  alt=""
                  class="carousel-body-grid-image carousel-one-image"
                  style={{
                    transform: "scale(1.5)",
                  }}
                />
              </div>
              <div class="grid-col-one third-right ">
                <img src={DATA_TRAIL} />
              </div>
            </div>
          </section>
        </div>
      </section>
    </>
  );
};

export default Section2;

// `<div class="body-item">
// {/* <img src="./assets/icons/target.png" alt="" class="body-item__image"> */}
// <div class="">
//   <h4 class="push-down-more body-item__title linear-red-yellow">
//     High-risk
//   </h4>
//   <p class="body-item__caption">~ $25,000 in damages</p>
// </div>
// </div>
// <div class="body-item">
// {/* <img src="./assets/icons/rain-drops.png" alt="" class="body-item__image"/> */}
// <div>
//   <h4 class="body-item__title linear-yellow-blue">
//     Moderate Risk
//   </h4>
//   <p class="body-item__caption">~ $7,000 in damages</p>
// </div>
// </div>
// <div class="body-item">
// {/* <img src="./assets/icons/rain-drops.png" alt="" class="body-item__image"/>  */}
// <div>
//   <h4 class="body-item__title linear-blue-blue">Low Risk</h4>
//   <p class="body-item__caption">~ $500 in damages</p>
// </div>
// </div>`
